import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59f64226"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0.5rem"} }
const _hoisted_2 = { class: "absolute-full flex flex-center bg-negative text-white" }
const _hoisted_3 = { class: "flex__column--center" }
const _hoisted_4 = { class: "app__title--small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_q_card, {
      class: "inline shadow-box",
      flat: "",
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_img, {
              transition: "fade",
              src: _ctx.urlToJPG+'/'+_ctx.category.pid,
              ratio: "1",
              fit: "scale-down",
              "spinner-color": "light-blue",
              class: "rounded-borders category__img"
            }, {
              error: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('message.cannot_load_image')), 1)
              ]),
              _: 1
            }, 8, ["src"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_actions, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$i18n.locale === 'ro' ? _ctx.category.name_ro : _ctx.$i18n.locale === 'en' ? _ctx.category.name_en : _ctx.category.name_bg), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_directive_ripple]
    ])
  ]))
}